import thunk from 'redux-thunk';
import { applyMiddleware } from 'redux';
import { createStateSyncMiddleware } from 'redux-state-sync';
import { PERSIST, PURGE, REHYDRATE } from 'redux-persist/es/constants';
import activityLogger from './activityLogger';
import partnerCustomer from './partnerCustomer';
import { AUTHENTICATE_SOCKET, JOIN_ROOMS, LEAVE_ROOM, PING } from '../store/socketio/types';
import { SOCKET_LOGOUT } from '../store/user/types';
import { ADDJTISUB, DELALLJTISUBS, DELJTISUB } from '../store/JTI/types';
import { WEATHERMAP_SUBSCRIBE } from '../store/weatherMap/types';
import SocketIOClient from './socketio/client';
import createSocketMiddleware from './socketio/middleware';

const config = {
  broadcastChannelOption: { type: 'localstorage' },
  predicate: action => ![PERSIST, PURGE, REHYDRATE].includes(action.type) && !action.type.startsWith('SERVICE'),
};

const isTestEnv = process.env.NODE_ENV === 'test';

const createNoopSocket = () => ({
  _callbacks: {},
  on(eventName, callback) {
    if (eventName) {
      this._callbacks[`$${eventName}`] = callback;
    }
    return this;
  },
  emit() {
    return this;
  },
  off(eventName) {
    if (eventName) {
      delete this._callbacks[`$${eventName}`];
    }
    return this;
  },
  removeAllListeners() {
    this._callbacks = {};
    return this;
  },
});

export const socketIOClient = new SocketIOClient();

const socketUrl = process.env.REACT_APP_SOCKETIO;
if (socketUrl) {
  socketIOClient.connect(socketUrl);
}

const socket = isTestEnv
  ? createNoopSocket()
  : socketIOClient.manager?.socket('/');

// a list of actions to send to socketIO
const socketMiddleware = createSocketMiddleware(socket, [
  AUTHENTICATE_SOCKET, SOCKET_LOGOUT,
  JOIN_ROOMS, LEAVE_ROOM,
  PING,
  WEATHERMAP_SUBSCRIBE,
  ADDJTISUB, DELALLJTISUBS, DELJTISUB,
]);

export default applyMiddleware(createStateSyncMiddleware(config), thunk, socketMiddleware, activityLogger, partnerCustomer);
